import type { LucideIcon } from 'lucide-react'
import {
  Package,
  Boxes,
  Palette,
  Truck,
  Wrench,
  TreePine,
  ShieldCheck,
  Briefcase,
} from 'lucide-react'
import type { RouteKey } from '@/i18n/routes'

export interface Division {
  id: string
  nameKey: string
  descKey: string
  color: string
  colorHex: string
  image: string
  logo: string
  routeKey: RouteKey
  icon: LucideIcon
}

export const divisions: Division[] = [
  {
    id: 'scatole',
    nameKey: 'divisions.scatole.name',
    descKey: 'divisions.scatole.desc',
    color: 'div-scatolificio',
    colorHex: '#2f2981',
    image: '/media/stabilimenti/Tecnocart_modena-187-scaled.jpg',
    logo: '/media/divisioni/Scatolificio-300x83.png',
    routeKey: 'divisionScatole',
    icon: Package,
  },
  {
    id: 'imballaggi',
    nameKey: 'divisions.imballaggi.name',
    descKey: 'divisions.imballaggi.desc',
    color: 'div-imballaggi',
    colorHex: '#4a8c2a',
    image: '/media/stabilimenti/Tecnocart_calderara-10-scaled.jpg',
    logo: '/media/divisioni/imballaggi-300x83.png',
    routeKey: 'divisionImballaggi',
    icon: Boxes,
  },
  {
    id: 'cartotecnica',
    nameKey: 'divisions.cartotecnica.name',
    descKey: 'divisions.cartotecnica.desc',
    color: 'div-cartotecnica',
    colorHex: '#e0882c',
    image: '/media/stabilimenti/Tecnocart_modena-181.jpg',
    logo: '/media/divisioni/cartotecnica1-300x83.png',
    routeKey: 'divisionCartotecnica',
    icon: Palette,
  },
  {
    id: 'trasporti',
    nameKey: 'divisions.trasporti.name',
    descKey: 'divisions.trasporti.desc',
    color: 'div-trasporti',
    colorHex: '#8b4d85',
    image: '/media/news/Flotta.jpg',
    logo: '/media/divisioni/trasporti.g.t.t-300x83.png',
    routeKey: 'divisionTrasporti',
    icon: Truck,
  },
  {
    id: 'macchinari',
    nameKey: 'divisions.macchinari.name',
    descKey: 'divisions.macchinari.desc',
    color: 'div-macchinari',
    colorHex: '#3d6e9e',
    image: '/media/stabilimenti/Tecnocart_calderara-81-scaled.jpg',
    logo: '/media/loghi/cropped-solo.logo_.blu_.tecnocart.imballaggi.png',
    routeKey: 'divisionMacchinari',
    icon: Wrench,
  },
  {
    id: 'legno',
    nameKey: 'divisions.legno.name',
    descKey: 'divisions.legno.desc',
    color: 'div-legno',
    colorHex: '#b5871f',
    image: '/media/prodotti/Bancale-In-legno.png',
    logo: '/media/loghi/cropped-solo.logo_.blu_.tecnocart.imballaggi.png',
    routeKey: 'divisionLegno',
    icon: TreePine,
  },
  {
    id: 'igiene',
    nameKey: 'divisions.igiene.name',
    descKey: 'divisions.igiene.desc',
    color: 'div-igiene',
    colorHex: '#5a6672',
    image: '/media/grafiche/IGIENEeMPNOUSO.jpeg',
    logo: '/media/loghi/cropped-solo.logo_.blu_.tecnocart.imballaggi.png',
    routeKey: 'divisionIgiene',
    icon: ShieldCheck,
  },
  {
    id: 'forniture',
    nameKey: 'divisions.forniture.name',
    descKey: 'divisions.forniture.desc',
    color: 'div-forniture',
    colorHex: '#b52020',
    image: '/media/grafiche/forniture-ufficio.png',
    logo: '/media/loghi/cropped-solo.logo_.blu_.tecnocart.imballaggi.png',
    routeKey: 'divisionForniture',
    icon: Briefcase,
  },
]
